import React from "react";

import NavLinks from "./NavLinks";
import Button from "../../shared/Button";
import Hamburger from "../components/Hamburger";
import logo from "../../assets/image/logo.svg";

import "./SideMenu.css";

const SideMenu = (props) => {
    
  return (
    <div className="sidemenu-container" style={props.style}>
      <div className="sidemenu-wrapper">
        <div className="sidemenu-header">
            <Hamburger onClick={props.Close} />
            <img src={logo} alt={"logo"}/>
        </div>
        <NavLinks className="sidemenu-links" />
        <Button btn="Sign In" className="btn-signin" onClick={props.signIn} />
        <Button btn="Sign Up" className="btn-signup" onClick={props.signUp} />
      </div>
    </div>
  );
};
export default SideMenu;
